import React from "react";
import { useTranslation } from "react-i18next";
import { Zone } from "@planzone/dto";
import { useZoneCreation } from "@planzone/view-models";
import { ZoneCreationForm } from "@common/zoneCreationForm";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function ZoneCreation({ planzone, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, createZone } = useZoneCreation();
  const [zone, setZone] = React.useState<Zone>({
    name: "",
    description: "",
    color: "#ef6167",
  });

  return (
    <Modal header={t("zoneCreation.title")} close={cancel}>
      <form
        className={styles.main}
        onSubmit={(e) => {
          e.preventDefault();

          !isRequestPending && createZone({ planzone, zone });
        }}
      >
        <div className={styles.form}>
          <ZoneCreationForm zone={zone} editForm={setZone} />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("zoneCreation.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
          >
            {t("zoneCreation.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { ZoneCreation };
